import React from 'react';
import { useSelector, useDispatch } from 'react-redux';

// import selectors
import { getDisplayEntry, getEntryById } from 'js/store/gallery/Gallery.selectors';

// import actions
import { toggleDisplayEntry } from 'js/store/gallery/Gallery.actions';

// import icons
import SvgCross from 'js/components/svg/Svg.cross';

const GalleryModal = () => {
  const dispatch = useDispatch();
  const displayEntry = useSelector((state) => {
    return getDisplayEntry(state);
  });

  const item = useSelector((state) => {
    return getEntryById(state, displayEntry);
  });

  const { id, title, mediaFile } = item || {};

  return (
    <div
      className="gallery-overlay"
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        zIndex: 99999,
        backgroundColor: 'rgba(26, 129, 117, 0.9)',
        display: displayEntry ? 'flex' : 'none',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <button
        style={{
          position: 'fixed',
          top: 0,
          right: 0,
          transformOrigin: 'left bottom',
          transform: 'translate(-15px, 15px)',
          cursor: 'pointer',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          backgroundColor: 'white',
          borderRadius: '50%',
          padding: '8px',
          boxShadow: '0 10px 8px 0 rgba(0, 0, 0, 0.25)',
          width: '10vw',
          height: '10vw',
          maxWidth: '78px',
          maxHeight: '78px',
        }}
        onClick={() => dispatch(toggleDisplayEntry(false))}
      >
        <SvgCross />
      </button>
      <figure
        style={{
          maxWidth: '90%',
          maxHeight: '75%',
          display: 'flex',
          position: 'relative',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          gap: '16px',
        }}
      >
        <picture
          style={{
            overflow: 'hidden',
            borderRadius: '24px',
            backgroundColor: 'white',
            border: '12px solid #D0D0F9',
            boxShadow: '0 24px 8px 0 rgba(0, 0, 0, 0.25)',
            maxWidth: '100%',
            maxHeight: '100%',
            aspectRatio: '1280 / 720',
          }}
        >
          <img src={mediaFile} alt={title} />
        </picture>
        <figcaption style={{ color: '#FCE90B', textAlign: 'center', marginTop: '8px', fontSize: '30px' }}>
          {title}
        </figcaption>
      </figure>
    </div>
  );
};

export default GalleryModal;
